"use client";

import { useIntl } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";

import { profileErrorMessages } from "./profiles.messages";

type ProfileErrorProps = {
  error: Error;
  reset: () => void;
};

/** Error boundary for the profile route. */
const ProfileError = ({ reset }: ProfileErrorProps) => {
  const intl = useIntl();
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-16 tw-py-64 tw-text-center">
      <Text element="h1" typeface="headline-4" className="tw-text-gray-900">
        {intl.formatMessage(profileErrorMessages.title)}
      </Text>
      <Button onClick={reset}>
        {intl.formatMessage(profileErrorMessages.cta)}
      </Button>
    </div>
  );
};

export default ProfileError;
